<div class="py-6 px-8 md:px-5 bg-primary">
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-3 py-5 md:py-5 lg:py-0">
      <div class="flex justify-content-center gap-5">
        <img src="assets/layout/images/gov.co_footer.png" width="146" height="28" alt="Gov CO icon">
        <img src="assets/layout/images/co_footer.png" width="54" height="51" alt="Co icon">
      </div>
    </div>
    <div
      class="col-12 md:col-6 lg:col-3 py-5 md:py-5 lg:py-0 border-top-1 border-white lg:border-left-1 md:border-y-none">
      <h4 class="font-medium text-2xl mb-3 text-900 text-white">Ministerio
        de las Culturas</h4>
      <div class="text-xl block text-700 text-white">Calle
        9 No. 8 31</div>
      <div class="text-xl block text-700 text-white">Bogotá
        D.C., Colombia</div>
      <h4 class="font-medium text-2xl text-900 text-white">Horario de
        atención:</h4>
      <div class="text-xl block text-700 text-white">Lunes
        a viernes de 8:00</div>
      <div class="text-xl block text-700 text-white">a.m.
        a 5:00 p.m. (días no festivos)</div>
      <div class="flex gap-3 mt-5 flex-wrap">
        <img src="assets/layout/images/icon-youtube.png" alt="Youtube icon" width="20" height="20"
          class="cursor-pointer">
        <img src="assets/layout/images/icon-instagram.png" alt="Instagram icon" width="20" height="20"
          class="cursor-pointer">
        <img src="assets/layout/images/icon-facebook.png" alt="Facebook icon" width="20" height="20"
          class="cursor-pointer">
        <img src="assets/layout/images/icon-twitter.png" alt="Twitter icon" width="20" height="20"
          class="cursor-pointer">
        <img src="assets/layout/images/icon-wa.png" alt="Whatsapp icon" width="20" height="20" class="cursor-pointer">
        <img src="assets/layout/images/icon-tiktok.png" alt="Tiktok icon" width="20" height="20" class="cursor-pointer">
      </div>
    </div>
    <div
      class="col-12 md:col-6 lg:col-3 py-5 md:py-5 lg:py-0 border-top-1 border-white md:border-top-1 lg:border-y-none lg:border-left-1">
      <h4 class="font-medium text-2xl line-height-3 mb-3 text-900 text-white">Contacto
        Correspondencia:</h4>
      <div class="line-height-3 text-xl block mb-2 text-700 text-white">
        <b>Presencial:</b> Lunes a viernes de 8:00 a.m. a
        3:00 p.m. jornada continua
        Casa Abadí­a, Calle 8 #8a-31
      </div>
      <p class="line-height-3 text-xl block mt-4 text-700"
        style="color: white !important; max-width: 100%; overflow-wrap: break-word;">
        <b>Virtual:</b> correo oficial - servicioalciudadanoamincultura.gov.co (los correos que se reciban después
        de las 5:00 p. m., se radicarán el siguiente día hábil)
      </p>
      <div class="line-height-3 text-xl block mt-4 text-700 text-white">
        <b>Teléfono:</b>
        (601) 3424100
      </div>
      <div class="line-height-3 text-xl block text-700 text-white"><b>Fax:</b>
        (601)
        3816353 ext. 1183</div>
      <div class="line-height-3 text-xl block text-700 text-white"><b>Lí­nea
          gratuita:</b> 018000 93808</div>
    </div>
    <div
      class="col-12 md:col-6 lg:col-3 py-5 md:py-5 lg:py-0 border-top-1 border-white md:border-top-1 lg:border-y-none lg:border-left-1">
      <h4 class="font-medium text-2xl line-height-3 mb-3 text-900 text-white">Servicios a la
        Ciudadanía</h4>
      <div class="line-height-3 text-xl block cursor-pointer mb-2 text-700 underline text-white">
        Notificaciones judiciales</div>
      <div class="text-xl block cursor-pointer mb-2 text-700 underline text-white">PQRSD
      </div>
      <div class="text-xl block cursor-pointer mb-2 text-700 underline text-white">
        Preguntas
        Frecuentes</div>
      <div class="text-xl block cursor-pointer mb-2 text-700 underline text-white">Glosario
      </div>
      <div class="text-xl block cursor-pointer text-700 underline text-white">Trámites y
        servicios</div>
      <h4 class="font-medium text-2xl line-height-3 mb-3 text-900 text-white">Acerca del sitio
      </h4>
      <div class="text-xl block cursor-pointer mb-2 text-700 underline text-white">
        Políticas</div>
      <div class="text-xl block cursor-pointer mb-2 text-700 underline text-white">
        Política
        de privacidad y protección de
        datos</div>
      <div class="text-xl block cursor-pointer mb-2 text-700 underline text-white">Mapa
        del
        sitio</div>
      <div class="text-xl block cursor-pointer mb-2 text-700 underline text-white">Términos y
        condiciones</div>
      <div class="text-xl block cursor-pointer text-700 underline text-white">
        Accesibilidad</div>
      <div class="text-xl block text-700 mt-5 text-white">Copyright © 2024</div>
    </div>
  </div>
</div>